import { Component, ErrorInfo, ReactNode } from "react"

import { faIcon } from "@utils/faIcon"

import { EmptyState } from "@molecules"

interface CodeScannerErrorBoundaryProps {
    children: ReactNode
}

interface CodeScannerErrorBoundaryState {
    hasFailed: boolean
}

// A class because React only hands render errors to class components. The scanner's decoder ships syntax older
// browsers can't parse, so its chunk failing to load or run must not take the page down with it.
class CodeScannerErrorBoundary extends Component<CodeScannerErrorBoundaryProps, CodeScannerErrorBoundaryState> {
    state: CodeScannerErrorBoundaryState = { hasFailed: false }

    static getDerivedStateFromError(): CodeScannerErrorBoundaryState {
        return { hasFailed: true }
    }

    componentDidCatch(error: Error, info: ErrorInfo) {
        console.error("The code scanner failed to load:", error, info.componentStack)
    }

    render() {
        if (this.state.hasFailed) {
            return (
                <EmptyState
                    variant="error"
                    icon={faIcon({ name: "camera-slash", style: "regular" })}
                    title="This browser can't scan"
                    supportText="Type the code instead, or open Roopairs in a current version of Safari or Chrome."
                />
            )
        }

        return this.props.children
    }
}

export default CodeScannerErrorBoundary
